import React from "react";

import { DeviceStatus } from "gql/generated/types";
import { Tag } from "primereact/tag";

const DeviceStatusTag: React.FC<{status: DeviceStatus}> = ({status}) => {
  switch (status) {
    case "OFFLINE":
      return <Tag value="Offline" severity="danger" />;
    case "ONLINE":
      return <Tag value="Online" severity="success" />;
    default:
      return <Tag value="No Data" severity="danger" />;
  }
}

export default DeviceStatusTag;